import styled from 'styled-components'
import { Theme } from '../../../../Theme';


const  Content = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    background-color: ${Theme.THIRD_COLOR};
    border-style: solid;
    border-width: 3px;
    border-color: ${Theme.FIRST_COLOR};
    border-radius: 20px;
    width: 40%;
    overflow: hidden;

    .ImgArea{
        width: 100%;
        height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;

        img{
            object-fit: cover;
            width: 100%;
            height: 100%;
        }

        .CloseArea{
            position: absolute;
            top: 5px;
            right: 5px;
            overflow: visible;
            cursor: pointer;

            img{
                width: 30px;
                height: 30px;
                object-fit: contain;
            }

        }
    }

    .TitleCurso{
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        gap: 10px;
        height: 40px;
       
        // letra sempre maiuscula
        text-transform: uppercase;
        color: ${Theme.FIRST_COLOR};
        img{
            height: 40px;
        }

        span{
            margin-top: 5px;
            font-size: 22px;
            font-weight: bold;
            font-family: ${Theme.THIRD_FONT};
        }
    }

    .InfoArea{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        width: 100%;
    }

    .DescriptionCurso{
        width: 90%;
        margin-top: 10px;
        font-family: ${Theme.SECOND_FONT};
        font-size: 16px;
        text-align: justify;
        max-height: 120px;
        overflow-y: auto;
    }

    .Conteudos{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
        width: 90%;
        gap: 5px;
        max-height: 120px;
        overflow-y: auto;
    }


    .TitleContent{
        font-weight: bold;
        margin-bottom: 5px;
        text-align: center;
    }

    .ButtonArea{
        width: 40%;
        margin: 15px;
    }

    // No Mobile
    @media (max-width: 768px) {
        width: 90%;
    }



`;

export const Styled = {
    Content
}